import { Button } from '../../../../../../components/Toolkit/Button/Button';
import {
  RevealPhoneNumber,
  type RevealPhoneNumberProps,
} from '../../../../../../components/PageWrappers/SharedComponents/RevealPhoneNumber/RevealPhoneNumber';
import { Columns } from '../../../../../../components/Toolkit/Columns/Columns';
import { EmailDealerOrSeller } from '../../EmailDealerOrSeller/EmailDealerOrSeller';
import { ReserveCTA } from '../../ReserveCTA/ReserveCTA';
import type { EmailDealerOrSellerProps } from '../../EmailDealerOrSeller/EmailDealerOrSeller.typed';
import type { ReservationStatuses } from '../../../types';

type ControlProps = {
  reservationStatus?: ReservationStatuses;
  displayContactDealershipBottomSheet: boolean;
  setIsContactSellerModalOpen(b: boolean): void;
  phoneResponse: boolean;
  emailResponse: boolean;
  phoneContactProps: RevealPhoneNumberProps;
  emailSellerProps: EmailDealerOrSellerProps;
};

const Control = (props: ControlProps) => {
  const {
    reservationStatus,
    displayContactDealershipBottomSheet,
    setIsContactSellerModalOpen,
    phoneResponse,
    emailResponse,
    phoneContactProps,
    emailSellerProps,
  } = props;
  return (
    <Columns>
      {reservationStatus && (
        <ReserveCTA reservationStatus={reservationStatus} />
      )}
      {displayContactDealershipBottomSheet && (
        <Button onClick={() => setIsContactSellerModalOpen(true)}>
          Contact Dealership
        </Button>
      )}
      {!displayContactDealershipBottomSheet && phoneResponse && (
        <RevealPhoneNumber {...phoneContactProps} />
      )}
      {!displayContactDealershipBottomSheet && emailResponse && (
        <EmailDealerOrSeller {...emailSellerProps} />
      )}
    </Columns>
  );
};

export { Control };
